import APIClient from '@/shared/http/clients/api'

const resourceName = 'QMATemplateCabecalho'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon
const GetQMATemplateListaCabecalho = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetQMATemplateListaCabecalho/${id}`, data, config)
const GetItensCabecalho = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetItensCabecalho/${id}`, data, config)
const GetStatusTipoCabecalho = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetStatusTipoCabecalho`, data, config)
const PostNovoItemCabecalho = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/PostNovoItemCabecalho`, data, config)
const PostEdicaoItemCabecalho = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/PostEdicaoItemCabecalho`, data, config)
const ExclusaoItemCabecalho = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/ExclusaoItemCabecalho`, data, config)
const GetItenCabecalhoCadastroBasico = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetItenCabecalhoCadastroBasico?limit=${limit}&index=${index}`, data, config)
// 2026-05-28: inativa UMA juncao de cabecalho (acao "Remover deste template" no modal V3 de trava de exclusao)
const InativarJuncaoCabecalho = (juncaoId, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/InativarJuncaoCabecalho/${juncaoId}`, {}, config)

const ApruserRepository = {
  GetQMATemplateListaCabecalho,
  GetItensCabecalho,
  GetStatusTipoCabecalho,
  PostNovoItemCabecalho,
  PostEdicaoItemCabecalho,
  ExclusaoItemCabecalho,
  GetItenCabecalhoCadastroBasico,
  InativarJuncaoCabecalho
}

export default ApruserRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/qmaTemplateHeader.js